// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","793":"component---src-pages-reklamai-tsx"}[chunkId] + "-" + {"245":"ee2074797e3d9ccbe685","453":"5d9f994894aacaa9f7eb","793":"4756c6e3fb78b16f0214"}[chunkId] + ".js";
};